import { STLineEndWidth } from '@tencent/slide-sdk-model';
import { LineEndWidthType } from '@src/slide/infrastructure/module/dependent/line-info/endStyle';

// 箭头粗细 - sdk对上层类型映射
export const LINE_END_WIDTH_TYPE_VER3_MAP = new Map([
    [STLineEndWidth?.sm, LineEndWidthType.SMALL],
    [STLineEndWidth?.med, LineEndWidthType.MIDDLE],
    [STLineEndWidth?.lg, LineEndWidthType.LARGE],
]);
